import React from "react";
import { Phone } from "lucide-react";

const CTA = () => {
  return (
    <section className="hob-cta-section">
      <div className="hob-cta-container">
        <div className="hob-cta-left">
          <h2 className="hob-cta-heading">
            Ready for a Pest Free Home or Business?
          </h2>
          <p className="hob-cta-description">
            Get a free inspection and a professional, eco-friendly and cost-effective pest control solution today!
          </p>
          <div className="hob-cta-button"
            onClick={() => (window.location.href = "tel:8530352444")}
            style={{ cursor: "pointer" }}
          >
            <Phone size={18} /> Call Now
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
